import moment from 'moment'

export const cleanData2Table = (prevData, currentData, noData) =>{
    let temp = {
        id: currentData.id_ctrl_infonavit,
        completed: currentData.completed ? true : false,
        files:[],
        data:[]
    }

    let fixedDataA = [
        currentData.businesses_name ? currentData.businesses_name : noData,
        currentData.rfc ? currentData.rfc : noData,
        currentData.client_status ? currentData.client_status : noData,
        currentData.client_classification ? currentData.client_classification : noData,
        currentData.fiscal_regime ? currentData.fiscal_regime : noData,
        currentData.infonavit_workers_limit ? currentData.infonavit_workers_limit : noData,
    ];

    let fixedDataB = [
        currentData.idse_user_state ? currentData.idse_user_state : noData,
        currentData.idse_user_employer_enrollment ? currentData.idse_user_employer_enrollment : noData,
        currentData.idse_user_city ? currentData.idse_user_city : noData,
        currentData.idse_user_user ? currentData.idse_user_user : noData,
        currentData.idse_user_password ? currentData.idse_user_password : noData,
        {key:'idse_user_digital_certificate'},
        currentData.idse_user_digital_certificate_password ? currentData.idse_user_digital_certificate_password : noData,
        currentData.idse_user_sipare ? currentData.idse_user_sipare : noData,
        currentData.idse_user_sua_password ? currentData.idse_user_sua_password : noData,
        currentData.idse_user_infonavit_user ? currentData.idse_user_infonavit_user : noData,
        currentData.idse_user_infonavit_email ? currentData.idse_user_infonavit_email : noData
    ]

    let varData = [
        currentData.presentation_limit_date ? moment(currentData.presentation_limit_date).format('DD-MM-YYYY') : noData,
        {key:'worksheet'},
        {key:'capture_line'},
        currentData.process ? currentData.process : noData,
        currentData.status ? currentData.status : noData,
        currentData.client_attention_info_1 ? currentData.client_attention_info_1 : noData,
        currentData.client_attention_info_2 ? currentData.client_attention_info_2 : noData,
        currentData.quantity_to_pay ? currentData.quantity_to_pay : noData,
        currentData.surcharges_and_updates ? currentData.surcharges_and_updates : noData,
        currentData.total_to_pay ? currentData.total_to_pay : noData,
        {key:'capture_line_imss_infonavit'},
        currentData.payment_limit_date ? moment(currentData.payment_limit_date).format('DD-MM-YYYY') : noData,
        {key:'client_response'},
        currentData.client_comment ? currentData.client_comment : noData,
        currentData.responsible ? currentData.responsible : noData,
        currentData.notes ? currentData.notes : noData,
        currentData.extra_hours ? currentData.extra_hours : noData,
        {key:'hours_proof'},
        currentData.extra_charges ? currentData.extra_charges : noData,
        {key:'charge_proof'},
        currentData.collections_charge ? currentData.collections_charge : noData,
        currentData.completition_date ? moment(currentData.completition_date).format('DD-MM-YYYY') : noData,
    ]

    let origin_data = {
        presentation_limit_date : currentData.presentation_limit_date,
        process : currentData.process,
        status : currentData.status,
        client_attention_info_1_id : currentData.client_attention_info_1_id,
        client_attention_info_2_id : currentData.client_attention_info_2_id,
        quantity_to_pay : currentData.quantity_to_pay,
        surcharges_and_updates : currentData.surcharges_and_updates,
        total_to_pay : currentData.total_to_pay,
        payment_limit_date : currentData.payment_limit_date,
        client_comment : currentData.client_comment,
        responsible_id: currentData.responsible_id,
        notes : currentData.notes,
        extra_hours : currentData.extra_hours,
        extra_charges : currentData.extra_charges,
        collections_charge : currentData.collections_charge,
        completition_date : currentData.completition_date
    }

    let tempA = {...temp}
    tempA.data = [...fixedDataA]
    prevData.fixedDataA.push(tempA);

    let tempB = {...temp}
    tempB.data = [...fixedDataB]
    tempB.files = [
        {id:currentData.id_ctrl_infonavit,key:'idse_user_digital_certificate',name:'Certificado Digital IDSE',path:'idseuserdigitalcertificate',
            status: checkStatus(currentData, 'idse_user_digital_certificate')},
    ]
    prevData.fixedDataB.push(tempB);

    let tempVar = {...temp}
    tempVar.data = [...varData]
    tempVar.files = [
        {id:currentData.id_ctrl_infonavit,key:'worksheet',name:'Hoja de Trabajo',path:'worksheet',
            status: checkStatus(currentData, 'worksheet')},
        {id:currentData.id_ctrl_infonavit,key:'capture_line',name:'Línea de Captura',path:'captureline',
            status: checkStatus(currentData, 'capture_line')},
        {id:currentData.id_ctrl_infonavit,key:'capture_line_imss_infonavit',name:'Línea Captura IMSS Infonavit',path:'capturelineimssinfonavit',
            status: checkStatus(currentData, 'capture_line_imss_infonavit')},
        {id:currentData.id_ctrl_infonavit,key:'client_response',name:'Respuesta Cliente',path:'clientresponse',
            status: checkStatus(currentData, 'client_response')},
        {id:currentData.id_ctrl_infonavit,key:'hours_proof',name:'Comprobante de horas',path:'hoursproof',
            status: checkStatus(currentData, 'hours_proof')},
        {id:currentData.id_ctrl_infonavit,key:'charge_proof',name:'Tabla SAT',path:'chargeproof',
            status: checkStatus(currentData, 'charge_proof')}
    ]
    tempVar.origin_data = {...origin_data}
    
    prevData.varData.push(tempVar);
    return prevData;
}

const checkStatus = (item, key) => {
    return item[key] !== "0" && item[key] !== 0 && item[key] !== ""
}
